<template>
  <v-combobox multiple chips
    label="Study Rights"
    placeholder="Select country"
    v-model="profile.studyRights"
    @input="modify"
    :items="countries" item-text="country" item-value="code"
    :filter="missingCountries"
    :search-input.sync="search"
    :loading="loading"
    :color="themes.candidate.light.input"
    return-object
    append-icon=""
    :menu-props="{ closeOnClick: true, closeOnContentClick: true }"
    :attach="attach"
    autofocus
  >
    <!-- Selection -->
    <v-chip avatar close
      slot="selection" slot-scope="data"
      @input="remove(data.item.id)"
      :class="themes.candidate.light.chip"
      :selected="data.selected"
      :key="`work-right-${data.item.id}`"
    >
      <v-avatar>
        <img
          :class="
            `flag-icon-background flag-icon-squared flag-icon-${data.item.countryCode.toLowerCase()}`
          "
        />
      </v-avatar>
      {{ data.item.country }}
    </v-chip>

    <!-- Options -->
    <v-list-tile avatar slot="item" slot-scope="data" @click="submit(data.item)">
      <v-list-tile-avatar>
        <img
          :class="
            `flag-icon-background flag-icon-squared flag-icon-${data.item.code.toLowerCase()}`
          "
        />
      </v-list-tile-avatar>
      <v-list-tile-content> <v-list-tile-title v-html="data.item.name" /> </v-list-tile-content>
    </v-list-tile>
  </v-combobox>
</template>

<script>
// Helpers
import _ from 'lodash'

// Data
import countries from '@/data/countries'

// Vue Component
export default {
  props: {
    attach: { type: Boolean, default: false },
    value: Array,
  },

  data() {
    return {
      // Data
      countries,
      // Loading indicator
      loading: false,
      // Search field
      search: '',
      // Model (object sent to API)
      profile: {
        studyRights: JSON.parse(JSON.stringify(this.value)),
      },
    }
  },

  methods: {
    missingCountries(item, queryText) {
      const pattern = queryText.replace(/[^a-zA-Z\s]/g,'')
      return (
        !_.find(this.profile.studyRights, ['countryCode', item.code]) &&
        new RegExp(pattern, 'i').test(item.name)
      )
    },

    modify(studyRights) {
      // Create any that were newly added
      const newValue = studyRights.filter(right => {
        return right.id && this.value.every(v => v.id !== right.id)
      })
      if (newValue && newValue[0]) this.submit(newValue[0])
      // Remove any that were removed with backspace
      const missingValues = this.value.filter(old => {
        return !_.some(studyRights, newValue => newValue.id === old.id)
      })
      if (missingValues.length) this.remove(missingValues[0].id)
      // Remove study rights without ids
      this.profile.studyRights = this.profile.studyRights.filter(sr => sr.id)
    },

    submit(country) {
      this.loading = true
      this.$store
        .dispatch('candidate/studyRights/create', {
          country: country.name,
          countryCode: country.code,
        })
        .then(
          () => this.$store.dispatch('snackbarSuccess', 'Saved'),
          () => this.$store.dispatch('snackbarError', 'Right not saved')
        )
        .finally(() => {
          this.reset()
        })
    },

    remove(id) {
      this.loading = true
      this.$store.dispatch('candidate/studyRights/destroy', id).finally(() => {
        this.reset()
      })
    },

    reset() {
      this.$store.dispatch('candidate/profile/fetch').finally(() => {
        this.profile.studyRights = JSON.parse(JSON.stringify(this.value))
        this.search = ''
        this.loading = false
      })
    },
  },
}
</script>
